import { ProgrammaTipoModel } from "./programmaTipo.model";

export class SaveBloccoModel {
  nomeBlocco: string;
  titolo: string;
  sottotitolo: string;
  colonneBlocco: number;
  righeBlocco: number;
  programmaTipo: ProgrammaTipoModel;

  id?: number;
  token?: string;

  dataInizio?: Date;
  dataFine?: Date;
  pubblicato: boolean;
  dataPubblicazione?: Date;

  codiceBloccoTipo?: string;
  tipoBlocco?: string;
  iFrameSrc?: string;
  linkSrc?: string;
  descrizione?: string;
  imageSrc?: string;
  image?: File;
  blocchiToDOWNLOAD?: Array<any>;
  blocchiIFRAMEUserDefined?: Array<{
    id: number;
    idBlocco: number;
    nome: string;
    valore: string;
  }>;
  blocchiLINKUserDefined?: Array<{
    id: number;
    idBlocco: number;
    nome: string;
    valore: string;
  }>;
  bloccoHTTPDataUserDefined?: Array<{
    id: number;
    idBlocco: number;
    nome: string;
    valore: string;
  }>;
  data?: Array<any>;
  idBloccoRouteAnagrafica?: number;
  json?: string;
  routeAnagrafica?: any;
  idBloccoDownloadExternalSourceDriver?: number;
  idBloccoDownloadExternalSourceDriverTipo?: number;
  externalSourceDriver: any;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/dashboard/saveBlocco.model.ts